// Файл table_column_widths_store.js

/**
 * Модуль содержит логику таблиц для настроек интерфейса.
 * Функция `widths_cache` обрабатывает данные своего сценария.
 * Функция `load_promises` загружает данные из соответствующего
 * источника.
 * Запросы данных выполняются через существующее взаимодействие с API.
 */

import { apiService } from '../../services/api';



const widths_cache = new Map();
const load_promises = new Map();
let full_profile_loaded = false;


const normalize_table_id = (value) => String(value ?? '').trim();




const normalize_widths = (value) => {
    if (!value || typeof value !== 'object' || Array.isArray(value)) {
        return {};
    }

    const normalized = {};

    Object.entries(value).forEach(([column_name, width]) => {
        const name = String(column_name ?? '').trim();
        const numeric_width = Number(width);

        if (!name || !Number.isFinite(numeric_width)) {
            return;
        }

        normalized[name] = Math.round(numeric_width);
    });

    return normalized;
};


const clone_widths = (value) => ({ ...(value || {}) });



export const install_table_column_widths = (value = {}) => {
    if (!value || typeof value !== 'object' || Array.isArray(value)) {
        return;
    }

    widths_cache.clear();
    full_profile_loaded = true;

    Object.entries(value).forEach(([table_id, widths]) => {
        const normalized_table_id = normalize_table_id(table_id);

        if (normalized_table_id) {
            const normalized_widths = normalize_widths(widths);

            widths_cache.set(
                normalized_table_id,
                normalized_widths,
            );
        }
    });
};

export const load_table_column_widths = async (table_id) => {
    const normalized_table_id = normalize_table_id(table_id);

    if (!normalized_table_id) {
        return {};
    }

    if (widths_cache.has(normalized_table_id)) {
        const cached = clone_widths(
            widths_cache.get(normalized_table_id)
        );

        return cached;
    }

    if (full_profile_loaded) {
        widths_cache.set(normalized_table_id, {});

        return {};
    }

    if (load_promises.has(normalized_table_id)) {
        return load_promises.get(normalized_table_id);
    }

    const load_promise = apiService.df({
        table_name: 'interface_customization_settings',
        params: {
            action: 'load_table_widths',
            table_id: normalized_table_id,
        },
    }).then((response) => {
        const widths = normalize_widths(response?.column_widths);
        widths_cache.set(normalized_table_id, widths);

        return clone_widths(widths);

    }).finally(() => {
        load_promises.delete(normalized_table_id);
    });

    load_promises.set(normalized_table_id, load_promise);

    return load_promise;
};


export const save_table_column_widths = async (table_id, widths) => {
    const normalized_table_id = normalize_table_id(table_id);
    const normalized_widths = normalize_widths(widths);

    if (!normalized_table_id) {
        return normalized_widths;
    }

    widths_cache.set(normalized_table_id, normalized_widths);

    const response = await apiService.df({
        table_name: 'interface_customization_settings',
        params: {
            action: 'save_table_widths',
            table_id: normalized_table_id,
        },
        table_data: normalized_widths,
    });
    const saved_widths = normalize_widths(
        response?.column_widths || normalized_widths
    );

    widths_cache.set(normalized_table_id, saved_widths);

    return clone_widths(saved_widths);
};
